import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { saveAs } from 'file-saver';
import { Redirect, Link } from 'react-router-dom';
import { Loader, Button, Icon } from 'semantic-ui-react';
import { find, findByIdAndRemove, findByIdAndSend } from '../../../actions/notificacao';
import MenuHorizontal from '../../layouts/MenuHorizontal';
import MenuVertical from '../../layouts/MenuVertical';
import { findById as findCondominioById } from "../../../actions/condominio";
import Notificacao from './Notificacao';
import CondominioVencido from '../admin/CondominioVencido';
import api from '../../../api';
import { base64toBlob } from '../../../utils/fileSaverHelper';

class Notificacoes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filtro: 'todas',
      loading: true,
      errors: {},
    };
  }

  componentDidMount = async () => {
    await this.props.findCondominioById(this.props.match.params.id);
    await this.props.find(this.props.condominio._id);
    this.setState({ loading: false, errors: { ...this.props.errors, ...this.props.errorsNotificacao } })
  };

  sendAction = async id => {
    this.setState({ loading: true });
    await this.props.findByIdAndSend(id);
    await this.props.find(this.props.condominio._id);
    this.setState({ loading: false, errors: { ...this.props.errors, ...this.props.errorsNotificacao } });
  };

  removeAction = async id => {
    this.setState({ loading: true });
    await this.props.findByIdAndRemove(id);
    await this.props.find(this.props.condominio._id);
    this.setState({ loading: false, errors: { ...this.props.errors, ...this.props.errorsNotificacao } })
  };

  onClickRel = async () => {
    const rel = await api.notificacao.relatorioGeral(this.props.condominio._id);
    saveAs(await base64toBlob(rel, 'application/pdf'), 'relatorio-geral-notificacoes.pdf');
  };

  render() {
    const { loading, errors, filtro } = this.state;
    const { notificacoes, condominio } = this.props;
    const enviadas = notificacoes.filter(n => !!n.dataEnvio).length;
    const visiveis = notificacoes.filter(n => filtro === 'todas' || (filtro === 'enviadas' ? !!n.dataEnvio : !n.dataEnvio));

    return (
      <div>
        {!!errors.global && <Redirect to="/" />}
        <MenuHorizontal />
        <div className="corpo-dashboard">
          <MenuVertical condominio={condominio} />
          <header className="va-un-cabecalho">
            <h1>Convocação digital e notificações</h1>
            <p>Envie convocações e avisos por e-mail e notificação no aplicativo dos moradores.</p>
          </header>
          <div className="va-un-barra-acoes">
            <CondominioVencido condominio={condominio}>
              <Button
                className="btn-ui-1"
                as={Link}
                to={`/condominios/${condominio._id}/notificacoes/cadastrar`}
                size="large"
              >
                <Icon name="plus" /> Cadastrar notificação
              </Button>
              <Button color="blue" size="large" onClick={this.onClickRel}>
                <Icon name="clipboard outline" /> Relatório geral
              </Button>
            </CondominioVencido>
          </div>
          <div className="va-un-filtros">
            <span className="va-contador">{visiveis.length} notificaç{visiveis.length === 1 ? 'ão' : 'ões'}</span>
            <div className="va-un-abas" role="tablist">
              {[
                ['todas', 'Todas', notificacoes.length],
                ['enviadas', 'Enviadas', enviadas],
                ['pendentes', 'Não enviadas', notificacoes.length - enviadas],
              ].map(([chave, rotulo, qtd]) => (
                <button
                  type="button"
                  role="tab"
                  aria-selected={filtro === chave}
                  key={chave}
                  className={filtro === chave ? 'ativo' : ''}
                  onClick={() => this.setState({ filtro: chave })}
                >
                  {rotulo} <span>{qtd}</span>
                </button>
              ))}
            </div>
          </div>
          {loading ?
              <Loader active inline="centered" style={{ marginTop: 50 }} />
            :
            !!visiveis.length ?
              <div className="va-notif-lista">
                {visiveis.map(notificacao => (
                  <Notificacao key={notificacao._id} notificacao={notificacao} sendAction={this.sendAction} removeAction={this.removeAction} />
                ))}
              </div>
              :
              <div className="empty-illustration-1">
                <img src="/images/illustrations/lupa-casa.svg" alt="Nenhuma Notificação Encontrada" />
                <p style={{ textAlign: 'center' }}>{notificacoes.length ? 'Nenhuma notificação com esse filtro.' : 'Você ainda não criou nenhuma notificação.'}</p>
              </div>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  condominio: state.condominio.condominio,
  notificacoes: state.notificacao.notificacoes,
  errors: state.condominio.errors,
  errorsNotificacao: state.notificacao.errors
});

const mapDispatchToProps = dispatch => bindActionCreators({
  find,
  findByIdAndRemove,
  findByIdAndSend,
  findCondominioById
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Notificacoes);
